module.exports = __webpack_public_path__ + "img/image-center.718546fc.svg";